.button-with-animation, .secondary-button {
    padding: 12px 32px;
    font-family: "Helvetica Neue";
    font-size: 18px;
    border-radius: 10px;
    color: #032320;
    font-weight: 500;
    transition: all 0.5s ease-in-out;
}

.button-with-animation.disabled, .secondary-button.disabled {
    opacity: 0.5;
    pointer-events: none;
}

.button-with-animation {
    position: relative;
    overflow: hidden;
    background-color: #DACBB7;
    height: 100%;
    max-height: 48px;

    .button-animation {
        display: inline-block;
        height: 76px;
        transform: rotate(-25deg);
        background-color: #FFFFFF40;
        position: absolute;
        top: -15px;
        transition: all 0.5s ease-in-out;
        outline: none;
    }

    .button-animation.first {
        width: 11px;
        left: -30px;
    }

    .button-animation.second {
        width: 5px;
        left: -15px;
        border-radius: 18px;
    }
}

.button-with-animation:hover {

    background-color: #D0B99B;

    .button-animation.first {
        width: 11px;
        left: calc(100% + 15px);
    }

    .button-animation.second {
        width: 5px;
        left: calc(100% + 30px);
        border-radius: 18px;
    }
}

.secondary-button {
    border: 1px solid #DACBB7;
}

.secondary-button:hover {
    background-color: #DACBB733;
}

.secondary-button.tertiary-button {
    color: #DACBB7;
}